import {
  IconAngleRight,
  IconBell,
  IconEnvelopeAlt,
  IconPen
} from '@maia/icons';
import { Button, InfoCard, PageHeader, StaticNotification } from '@maia/ui';
import { createFileRoute, Link } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/edit/success',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { guid } = Route.useParams();
  return (
    <div className="layout-sidebar">
      <PageHeader
        title="Contactgegevens wijzigen"
        description=""
        className="area-page-header"
      />

      <div className="area-page-content content-grid">
        <StaticNotification
          variant="info"
          size="small"
          className="col-span-full"
        >
          <span className="font-medium">Goed om te weten!</span> De wijziging is nog niet verwerkt. Tot die tijd blijven de huidige gegevens staan.
        </StaticNotification>

        <ul className="space-y-12 col-span-full">
          <li>
            <InfoCard
              icon={IconBell}
              title="Automatische controles"
              description="We controleren of de wijziging kan worden doorgevoerd of extra beoordeling nodig heeft."
            />
          </li>
          <li>
            <InfoCard
              icon={IconPen}
              title="Beoordeling door een acceptant"
              description="Een acceptant controleert de aanvraag en bepaalt of de wijziging kan worden doorgevoerd."
            />
          </li>
          <li>
            <InfoCard
              icon={IconEnvelopeAlt}
              title="De klant ontvangt bericht"
              description="De klant ontvangt bericht zodra de wijziging verwerkt is."
            />
          </li>
        </ul>

        <div className="col-span-full flex justify-end">
          <Link to="/customers/$guid" params={{ guid }}>
            <Button intent="primary" iconRight={IconAngleRight}>
              Naar klant
            </Button>
          </Link>
        </div>
      </div>
      <div className="area-page-sidebar invisible" />
    </div>
  );
}
